import { UserFormat } from '../interfaces/user-format.interface';
import { UserDateFormat } from '../enums/user-date-format.enum';

export function mapUserFormat(userFormat: UserFormat): UserFormat {
	return {
		date: yearToLowerCase(userFormat.date) as UserDateFormat,
		time: userFormat.time,
		number: userFormat.number,
	};
}

function yearToLowerCase(format: UserDateFormat): UserDateFormat {
	return format.replace(/YY/g, 'yy') as UserDateFormat;
}
